var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.0786365,
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 28C34.0609 28 26 34.4762 26 42.4762C26 50.4762 34.0609 56.9524 44 56.9524C45.5652 56.9524 47.2087 56.8 48.7739 56.419L57.7739 59.9238C57.8522 59.9238 57.9304 60 58.087 60C58.2435 60 58.4 59.9238 58.5565 59.8476C58.7913 59.6952 58.8696 59.3905 58.8696 59.1619L58.0087 51.5429C60.5913 49.0286 62 45.7524 62 42.4762C62 34.4762 53.9391 28 44 28Z",
    fill: "#F45634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.012524c265c2d1fb7ee2701aff9e037e.svg";
export { ForwardRef as ReactComponent };